import React, { useEffect, useMemo, useState } from "react";
import {
  MRT_ShowHideColumnsButton,
  MaterialReactTable,
} from "material-react-table";
import { Box } from "@mui/material";
import { FaGripLinesVertical } from "react-icons/fa";
import { mui_MRT_TextfieldInput_fontSizeStyle } from "../../features/access_list/styles/muiStyle";
import { useUserStore } from "../../../../../store/user.store";
export const CustomMRTInstance = (props) => {
  const columns = useMemo(() => props.headers, [props.headers]);
  const data = useMemo(() => props.tableData, [props.tableData]);
  const resetPageNumberHandler = useUserStore(
    (state) => state.resetPageNumberHandler
  );

  const [sorting, setSorting] = useState([]);

  useEffect(() => {
    // Sort value will always return one object in the array because multiple sorting is disabled on client and server side
    if (sorting?.length && props.onSortingChange) {
      props.onSortingChange(sorting[0]);
      resetPageNumberHandler();
    }
  }, [sorting]);

  const [globalFilter, setGlobalFilter] = useState("");

  return (
    <>
      <div className="card">
        <MaterialReactTable
          manualFiltering
          onGlobalFilterChange={(val) => {
            props.searchCallBack(val);
            setGlobalFilter(val);
          }}
          manualSorting={props.enableManualSorting ?? true}
          muiSearchTextFieldProps={{
            placeholder: "Search all users",
            style: {
              "--cust-padding": "0.2em", //Yes the linters will flag this as an error, it works, ok, it works
            },
            sx: {
              ...mui_MRT_TextfieldInput_fontSizeStyle,
              fontSize: "1.2em", // Change this fontsize and --cust-padding to change size of search bar
            },
            variant: "outlined",
          }}
          enableMultiSort={false}
          onSortingChange={setSorting}
          enableColumnPinning={props.enableColumnPinning}
          onEditingRowCancel={props.onEditingRowCancel}
          enableRowNumbers={props.enableRowNumbers}
          enableColumnActions={false}
          columns={columns}
          data={data}
          enableStickyHeader
          enablePagination={props.enablePagination ?? false}
          enableColumnDragging
          enableColumnOrdering
          getRowId={(row) => row.id}
          renderCellActionMenuItems={props.renderCellActionMenuItems}
          initialState={{
            columnVisibility: props.columnVisibility,
            ...props.initialState,
            showGlobalFilter: props.enableSearch ? true : false,
          }}
          // state management for row selection
          onRowSelectionChange={props.setRowSelection} //connect internal row selection state to your own
          state={{
            ...props.rowSelection,
            isLoading: props.isLoading,
            sorting,
            globalFilter,
          }} //pass our managed row selection state to the table to use
          // editing table data
          editingMode={props.editingMode}
          enableEditing={props.enableEditing}
          onEditingRowSave={props.onEditingRowSave}
          onEditingRowChange={props.onEditingRowChange}
          // render more menu options
          positionActionsColumn="last"
          enableRowSelection={
            props.enableRowSelection ? props.enableRowSelection : (row) => false
          }
          displayColumnDefOptions={props.displayColumnDefOptions}
          enableRowActions={props.enableRowActions}
          renderRowActionMenuItems={props.rowAction}
          renderRowActions={props.renderRowActions}
          renderTopToolbarCustomActions={({ table }) => (
            <Box
              sx={{
                // display: "flex",
                // flexDirection: "row",
                fontFamily: "poppins",
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "24px",
                paddingLeft: "5px",
                gap: "1rem",
                p: "0.5rem",
                // flexWrap: "wrap",
              }}
            >
              {/* toptoolbar */}
              {props.tableTitle && props.tableTitle}

              {props.renderTopToolbarCustomActions && (
                <div className="tw-mt-3 tw-flex tw-flex-wrap tw-gap-2 ">
                  {props.renderTopToolbarCustomActions(table)}
                </div>
              )}
            </Box>
          )}
          renderTopToolbar={props.renderTopToolbar}
          renderToolbarInternalActions={({ table }) => (
            <Box sx={{ display: "flex" }}>
              <div className="tw-flex tw-items-center tw-gap-x-2 tw-px-2">
                {/* <span className="tw-text-primary-blue tw-text-xs font-w500">
                  Select
                </span> */}
                <MRT_ShowHideColumnsButton table={table} />
              </div>
            </Box>
          )}
          renderBottomToolbarCustomActions={({ table }) =>
            props.paginateComponent
          }
          // enableRowSelection // component needs to re-rendered to refelect hidden or shown bulkactions
          enableFullScreenToggle={false}
          enableGlobalFilter={props.enableGlobalFilter ?? false}
          enableDensityToggle={false}
          enableColumnFilters={false}
          // Add onclick action to table rows
          muiTableProps={props.muiTableProps ?? {}}
          muiTableBodyRowProps={
            props.muiTableBodyRowProps ??
            (({ row }) => ({
              onClick: () => {
                props.onRecordClick && props.onRecordClick(row);
              },
              sx: {
                cursor: "pointer",
              },
              className: `${
                props.className ? props.className + " " : ""
              }[&_td>p]:tw-min-w-max [&_td>p]:tw-m-auto`,
            }))
          }
          muiTablePaperProps={
            props.muiTablePaperProps ?? {
              sx: {
                borderRadius: "8px",
                overflow: "hidden",
              },
            }
          }
          muiTableHeadCellProps={
            props.muiTableHeadCellProps ?? {
              sx: {
                fontFamily: "poppins",
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "24px",
                color: "#212121",
              },
            }
          }
          muiTableBodyCellProps={
            props.muiTableBodyCellProps ??
            (({ cell }) => ({
              sx: {
                fontFamily: "poppins",
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "20px",
                color: "#666666",
                textTransform: "capitalize",
              },
            }))
          }
          muiTableHeadProps={{
            sx: {
              "& tr>th:first-child": {
                display: props.enableRowSelection ? "tabel-cell" : "none",
                width: props.enableRowSelection ? "2em" : "0",
              },
            },
          }}
          muiTableBodyProps={{
            sx: {
              "& tr>td:first-child": {
                display: props.enableRowSelection ? "tabel-cell" : "none",
                width: props.enableRowSelection ? "2em" : "0",
              },
            },
          }}
          icons={{
            DragHandleIcon: () => <FaGripLinesVertical size={15} />,
          }}
        />
      </div>
    </>
  );
};
export default CustomMRTInstance;
